import { render, staticRenderFns } from "./IconRewardTotalRedeem.vue?vue&type=template&id=99256288"
import script from "./IconRewardTotalRedeem.vue?vue&type=script&lang=js"
export * from "./IconRewardTotalRedeem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports